import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = { class: "text-2xl font-bold text-[#C59C2F] mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-4 mb-6"
}
const _hoisted_4 = { class: "text-white font-semibold text-lg" }
const _hoisted_5 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_6 = {
  key: 2,
  class: "text-gray-400 text-sm"
}
const _hoisted_7 = {
  key: 3,
  class: "grid grid-cols-2 gap-4 mb-6"
}
const _hoisted_8 = {
  key: 4,
  class: "sticky bottom-0 bg-black py-4 flex justify-center"
}
const _hoisted_9 = ["disabled"]

import { ref, onMounted, watch } from 'vue';
import { db } from '@/config/firebase';
import {
  getDoc,
  doc,
  collection,
  query,
  where,
  getDocs,
  setDoc,
} from 'firebase/firestore';
import {
  format, addDays, parse, subDays,
} from 'date-fns';

import SelectableCard from '@/components/admin-dashboard/SelectableCard.vue';
import DatePicker from '@/components/admin-dashboard/DatePicker.vue';
import useToast from '@/composables/useToast';
import Toast from '@/components/Toast.vue';
// import { ChevronRightIcon } from '@vue-hero-icons/outline';

// TEMPORARY: hardcoded partnerCompanyId (later from auth user session)
const partnerCompanyId = 'ukraine-cleaning';


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerSlotsDashboard',
  setup(__props) {

const service = ref<any>(null);

const selectedDate = ref('');
const unavailableSlots = ref<string[]>([]);
const loading = ref(false);
const saving = ref(false);
const showDatePicker = ref(false);

const toast = useToast();

const showToast = ref(false);

async function fetchService() {
  try {
    const servicesRef = collection(db, 'services');
    const q = query(
      servicesRef,
      where('config.partnerCompany', '==', partnerCompanyId),
    );
    const snap = await getDocs(q);

    if (!snap.empty) {
      service.value = snap.docs[0].data();
      service.value.id = snap.docs[0].id;
      // auto-set selected date based on minDaysAhead
      const minDays = service.value.slotTemplate?.minDaysAhead ?? 2;
      const defaultDate = addDays(new Date(), minDays);
      selectedDate.value = format(defaultDate, 'dd-MM-yyyy');
    }
  } catch (err) {
    console.error('Failed to fetch service', err);
  }
}

async function loadUnavailableSlots() {
  if (!service.value || !selectedDate.value) return;

  loading.value = true;
  try {
    const parsedDate = parse(selectedDate.value, 'dd-MM-yyyy', new Date());
    const stringDate = format(parsedDate, 'dd-MM-yyyy');

    const refDoc = doc(
      db,
      'partnerCompanies',
      partnerCompanyId,
      'availability',
      stringDate,
    );
    const snap = await getDoc(refDoc);

    if (snap.exists()) {
      unavailableSlots.value = (snap.data()?.unavailableSlots || []).map(
        (slot) => `${slot.start}-${slot.end}`,
      );
    } else {
      unavailableSlots.value = [];
    }
  } catch (err) {
    console.error('Failed to load slots', err);
  } finally {
    loading.value = false;
  }
}

async function saveUnavailableSlots() {
  saving.value = true;
  try {
    const parsedDate = parse(selectedDate.value, 'dd-MM-yyyy', new Date());
    const stringDate = format(parsedDate, 'dd-MM-yyyy');

    const refDoc = doc(
      db,
      'partnerCompanies',
      partnerCompanyId,
      'availability',
      stringDate,
    );

    await setDoc(refDoc, {
      serviceId: service.value.id,
      date: stringDate,
      unavailableSlots: unavailableSlots.value.map((str) => {
        const [start, end] = str.split('-');
        return { start, end };
      }),
    });
    console.log(toast);
    showToast.value = true;

    setTimeout(() => {
      showToast.value = false;
    }, 3000);
    if (!service.value || !selectedDate.value) return;
  } catch (err) {
    console.error('Save failed', err);
    alert('Failed to save availability');
  } finally {
    saving.value = false;
  }
}

function toggleSlot(slotId: string) {
  if (unavailableSlots.value.includes(slotId)) {
    unavailableSlots.value = unavailableSlots.value.filter(
      (id) => id !== slotId,
    );
  } else {
    unavailableSlots.value.push(slotId);
  }
}

function changeDay(direction: 'prev' | 'next') {
  const current = parse(selectedDate.value, 'dd-MM-yyyy', new Date());
  const newDate = direction === 'prev' ? subDays(current, 1) : addDays(current, 1);
  selectedDate.value = format(newDate, 'dd-MM-yyyy');
}

watch(selectedDate, () => {
  loadUnavailableSlots();
});

onMounted(() => {
  fetchService();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (showToast.value)
          ? (_openBlock(), _createBlock(Toast, {
              key: 0,
              variant: "success",
              title: "Success",
              message: "Availability updated successfully",
              class: "absolute top-[5%] right-[2%] z-99999"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("h1", _hoisted_2, "Manage Availability - " + _toDisplayString(service.value?.title), 1),
    (service.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeDay('prev'))),
            class: "text-[#C59C2F]"
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(
            _unref(parse)(selectedDate.value, "dd-MM-yyyy", new Date()),
            "EEEE, dd MMMM yyyy"
          )), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeDay('next'))),
            class: "text-[#C59C2F]"
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
          ])),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showDatePicker.value = !showDatePicker.value)),
            class: "ml-auto text-[#C59C2F]"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
          ]))
        ]))
      : _createCommentVNode("", true),
    (showDatePicker.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(DatePicker, {
            modelValue: selectedDate.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDate).value = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading slots..."))
      : (service.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.value.config.slotTemplate.slots, (slot, i) => {
              return (_openBlock(), _createBlock(SelectableCard, {
                key: i,
                label: `${slot.start} - ${slot.end}`,
                selected: !unavailableSlots.value.includes(`${slot.start}-${slot.end}`),
                disabled: unavailableSlots.value.includes(`${slot.start}-${slot.end}`),
                onClick: ($event: any) => (toggleSlot(`${slot.start}-${slot.end}`))
              }, null, 8, ["label", "selected", "disabled", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    (service.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: saveUnavailableSlots,
            class: "bg-[#C59C2F] text-black font-semibold px-6 py-3 rounded-xl",
            disabled: saving.value
          }, _toDisplayString(saving.value ? "Saving..." : "Save Availability"), 9, _hoisted_9)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})